<template>
  <div
    :class="[$style.genericIcon, colorStyle]"
    :style="{ backgroundColor: modelColor }"
  >
    <p :class="$style.genericIconLetter">
      {{ modelDisplayLabel.charAt(0).toUpperCase() }}
    </p>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { get } from 'lodash';
import { mapState } from 'vuex';

const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

export default {
  name: 'AvatarColor',

  props: {
    colorStyle: {
      default: '',
      type: String,
    },
  },

  computed: {
    ...mapState(applicationModel, [
      'item',
    ]),

    modelColor() {
      return get(this, 'item.logo.color') || get(this, 'item.color');
    },

    modelDisplayLabel() {
      return get(this, 'item.displayLabel') || '';
    },
  },
};
</script>

<style module>
.genericIcon {
  border-radius: 28px;
  height: 54px;
  line-height: 52px;
  margin: 0 auto;
  text-align: center;
  width: 55px;
}

.genericIconLetter {
  color: white !important;
  font-size: 34px;
  font-weight: 400;
}
</style>
